
import React from 'react';

import { useStore } from '../../hooks';
import { CLOSING_REASONS } from '../../utils/constants';
import TopbarIconButton from './TopbarIconButton';

function AiOutlineCloseCircle(props) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth={0}
      viewBox="0 0 1024 1024"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 7.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
    </svg>
  );
}

const CloseButton = () => {
  const {
    haveNotSavedChanges,
    config: { onClose },
    t,
  } = useStore();

  if (typeof onClose !== 'function') {
    return null;
  }

  const closeWithReason = () => {
    onClose(CLOSING_REASONS.CLOSE_BUTTON, haveNotSavedChanges);
  };

  return (
    <TopbarIconButton
      className="respark_topbar-btn--close"
      title={t('close') || 'Close'}
      onClick={closeWithReason}
    >
      <AiOutlineCloseCircle />
    </TopbarIconButton>
  );
};

export default CloseButton;
